function numberFormat(number, decimals, decPoint, thousandsSep) {
  decimals = 2 // 这里默认设置保留两位小数，也可以注释这句采用传入的参数
  /*
 3     * 参数说明：
 4     * number：要格式化的数字
 5     * decimals：保留几位小数
 6     * decPoint
 7     * thousandsSep
 8     * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + Math.ceil(n * k) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

// number_format(1234567.089, 2, ".", ","); //1,234,567.09 上面方法小数点多位向前+1

// 上面是多位小数四舍五入
// function number_format(number, decimals, dec_point, thousandsSep) {
//   /*
//    * 参数说明：
//    * number：要格式化的数字
//    * decimals：保留几位小数
//    * dec_point：小数点符号
//    * thousandsSep：千分位符号
//    * */
//   number = (number + '').replace(/[^0-9+-Ee.]/g, '');
//   var n = !isFinite(+number) ? 0 : +number,
//     prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//     sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
//     dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
//     s = '',
//     toFixedFix = function (n, prec) {
//       var k = Math.pow(10, prec);
//       return '' + Math.floor(n * k) / k;
//     };
//   s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
//   var re = /(-?\d+)(\d{3})/;
//   console.log(s)
//   while (re.test(s[0])) {
//     s[0] = s[0].replace(re, "$1" + sep + "$2");

//   }
//   if ((s[1] || '').length < prec) {
//     s[1] = s[1] || ''
//     s[1] += new Array(prec - s[1].length + 1).join('0');
//   }
//   return s.join(dec);
// }
// number_format(1234567.089, 2, ".", ","); //1,234,567.08 直接舍去的办法
export {
  numberFormat // 通过此处导出方法
}
